import { Category } from 'infra/type'
import { makeAutoObservable } from 'mobx'

export class CategorySelectStore {
  data: Category[] = []

  // 레벨 별로 들어감
  selected: number[] = []

  constructor() {
    makeAutoObservable(this)
  }

  initData(data: Category[]) {
    this.data = data
  }

  selectInitData(initData: number[]) {
    this.selected = [...initData]
  }

  get leaf() {
    if (!this.selected?.length) return null
    return this.selected[this.selected.length - 1]
  }

  get flattenData(): Category[] {
    const data: Category[] = []
    this.data.forEach((x) => {
      data.push(x)
      if (x.sub_categories) {
        data.push(...x.sub_categories)
      }
    })
    return data
  }

  get l2CategoriesToShow(): Category[] {
    if (!this.selected.length) return []
    return (
      this.data.find((x) => x.id === this.selected[0])?.sub_categories || []
    )
  }

  get selectedData(): Category[] {
    return this.selected.flatMap((categoryId) => {
      const category = this.flattenData.find((x) => x.id === categoryId)
      return category ? [category] : []
    })
  }

  checkIsL1CategorySelected(category: Category): boolean {
    if (this.selected.length < 1) return false
    return this.selected[0] === category.id
  }

  checkIsL2CategorySelected(category: Category): boolean {
    if (this.selected.length < 2) return false
    return this.selected[1] === category.id
  }

  selectL1Category(category: Category) {
    this.selected = [category.id]
  }

  deselectCategory(_category: Category) {
    // // if l1
    // if (
    //   (category.sub_categories && category.sub_categories.length > 0) ||
    //   // TODO: 임시 처리해둠, 뭔가 데이터에 직접적인 마킹이 필요할 것 같다
    //   category.name.includes('작업하기 좋은 카페')
    // ) {
    //   this.selected = []
    // }
    // // if l2
    // else {
    //   this.selected = this.selected.slice(0, 1)
    // }
    // 상위 카테고리만 사용
    this.selected = []
  }

  selectL2Category(category: Category) {
    if (!this.data.length) return
    // unselect: remove if already exists
    if (this.selected.find((x) => x === category.id)) {
      this.selected = this.selected.slice(0, 1)
    }
    // select: add if not
    else {
      this.selected = [...this.selected.slice(0, 1), category.id]
    }
  }
}

// TODO: remove global usage?
export const categorySelectStore = new CategorySelectStore()
